//Built-in libraries

//Third party libraries
import { useLocation, useNavigate } from "react-router-dom";

//Custom components
import Table from "components/UI/Table";
import { MDGSFiltersForm } from "./MDGSFiltersForm";

//Services
import { convertEnumToText } from "utils";
import { useApplicationsListContext } from "features/ApplicationForm/Components/ApplicationsList/ApplicationsListProvider";

//STP Libraries

//Assets and Miscellaneous
import Styles from "./styles.module.css";

//Component Begin

export const MDGSApplicationsList = () => {
  const {
    data,
    tablePagination,
    showFilterModal,
    toggleFilterModal,
    applyFiltersHandler,
  } = useApplicationsListContext();

  const navigate = useNavigate();
  const location = useLocation();

  const tableColumns = [
    {
      id: "proposerName",
      Header: "Proposer Name",
      accessor: "applicationData",
      minWidth: 250,
      maxWidth: 250,
      Cell: (row: any) => {
        const applicationInformation = row.value?.applicantInformation;
        return (
          <div className="text-sm text-neutralColor-medium flex flex-col max-w-md">
            <span className="truncate">{applicationInformation?.fullName}</span>
            <span className="text-xs text-neutralColor-normal">
              {applicationInformation.contactEmail}
            </span>
          </div>
        );
      },
    },
    {
      id: "bondBillInfo",
      Header: "Bond Bill Info",
      accessor: "applicationData",
      minWidth: 250,
      maxWidth: 250,
      Cell: (row: any) => {
        const projectDetails = row?.value?.step1?.section1;
        return (
          <div className="flex flex-col gap-1">
            <span className="truncate">{projectDetails?.name}</span>
            <span>{projectDetails?.streetAddress}</span>
            <span className="text-xs text-neutralColor-normal">
              {projectDetails?.city}, {projectDetails?.state}
            </span>
            <span className="text-xs text-neutralColor-normal">
              {projectDetails?.zipCode}
            </span>
          </div>
        );
      },
    },
    {
      id: "status",
      Header: "Status",
      accessor: "status",
      minWidth: 250,
      maxWidth: 250,
      Cell: (row: any) => {
        return (
          <div className="flex items-center w-full capitalize">
            <span className={`${Styles[row.value]}`}>
              {convertEnumToText(row.value)}
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Table
        cols={tableColumns}
        tableData={data?.data}
        onRowClick={(row: any) => navigate(`${location.pathname}/${row.id}`)}
        pagination={tablePagination}
      />

      {showFilterModal && (
        <MDGSFiltersForm
          handleModal={toggleFilterModal}
          handleApplyFilter={applyFiltersHandler}
        />
      )}
    </>
  );
};
